<template>
    <div>
      <input type="checkbox" id="check">
      <!--header area start-->
      <header>
        <label for="check">
          <i class="fas fa-bars" id="sidebar_btn"></i>
        </label>
        <div class="left_area">
          <h3>Expar <span>STORE</span></h3>
        </div>
        <div class="right_area">
          <a href="./" class="logout_btn" @click="logout">Logout</a>
        </div>
      </header>
      <!--header area end-->
      <!--mobile navigation bar start-->
      <div class="mobile_nav">
        <div class="nav_bar">
            <!-- <img src="../assets/static/images/expar_logo_white.png" class="mobile_profile_image" alt=""> -->
            <i class="fa fa-bars nav_btn" @click="isActive = !isActive"></i>
        </div>
        <div class="mobile_nav_items" v-bind:class="{ active: isActive}">
			<router-link 
				:to="{ name: 'adminPanel' }"
				:class="activeTab === 'admin-panel' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'admin-panel'"
				:onclick="topFunction()">
				<font-awesome-icon icon="users" />
				<span>Admin panel</span>
			</router-link>

			<router-link 
				:to="{ name: 'adminProfile' }"
				:class="activeTab === 'adminProfile' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'adminProfile'"
				:onclick="topFunction()">
				<font-awesome-icon icon="address-card" />
				<span>Profile</span>
			</router-link>

			<router-link 
				:to="{ name: 'clientList' }"
				:class="activeTab === 'clientList' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'clientList'"
				:onclick="topFunction()">
				<font-awesome-icon icon="user-tie" />
				<span>Clients</span>
			</router-link>

			<router-link 
				:to="{ name: 'marketPlaceList' }"
				:class="activeTab === 'marketPlaceList' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'marketPlaceList'"
				:onclick="topFunction()">
				<font-awesome-icon icon="store" />
				<span>Marketplace</span>
			</router-link>

			<router-link 
				:to="{ name: 'metricsAdmin' }"
				:class="activeTab === 'metricsAdmin' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'metricsAdmin'"
				:onclick="topFunction()">
				<font-awesome-icon icon="tachometer-alt" />
				<span>Metrics</span>
			</router-link>

			<router-link 
				:to="{ name: 'settingsAdmin' }"
				:class="activeTab === 'settingsAdmin' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'settingsAdmin'"
				:onclick="topFunction()">
				<font-awesome-icon icon="cogs" />
				<span>Settings</span>
			</router-link>
        </div>
      </div>
      <!--mobile navigation bar end-->
      <!--sidebar start-->
      <div class="sidebar">
        <!-- <router-link :to="{ name: 'adminPanel' }" class="no-hover">
          <div class="profile_info">
            <img src="../assets/static/images/expar_logo_white.png" class="profile_image" alt="">
            <h4>ADMIN PANEL</h4>
          </div>
        </router-link> -->
		<router-link 
			:to="{ name: 'adminPanel'}"
			:class="activeTab === 'admin-panel' ? 'sidebar_active' : 'sidebar_nonactive'"
			@click.native="activeTab = 'admin-panel'"
			:onclick="topFunction()">
			<font-awesome-icon class="icon" icon="users" />
			<span style="margin-left: 15px; font-size: 1.3em">Admin panel</span>
		</router-link>

        <router-link 
			:to="{ name: 'adminProfile'}"
			:class="activeTab === 'adminProfile' ? 'sidebar_active' : 'sidebar_nonactive'"
			@click.native="activeTab = 'adminProfile'"
			:onclick="topFunction()">
			<font-awesome-icon class="icon" icon="address-card" />
			<span style="margin-left: 15px; font-size: 1.3em">Profile</span>
		</router-link>

        <router-link 
			:to="{ name: 'clientList' }"
			:class="activeTab === 'clientList' ? 'sidebar_active' : 'sidebar_nonactive'"
			@click.native="activeTab = 'clientList'"
			:onclick="topFunction()">
			<font-awesome-icon style="margin-left:5px;" class="icon" icon="user-tie" />
			<span style="margin-left: 20px; font-size: 1.3em">Clients</span>
		</router-link>

		<router-link 
			:to="{ name: 'marketPlaceList' }"
			:class="activeTab === 'marketPlaceList' ? 'sidebar_active' : 'sidebar_nonactive'"
			@click.native="activeTab = 'marketPlaceList'"
			:onclick="topFunction()">
			<font-awesome-icon class="icon" icon="store" />
			<span style="margin-left: 10px; font-size: 1.3em">Marketplace</span>
		</router-link>

		<router-link 
			:to="{ name: 'metricsAdmin' }"
			:class="activeTab === 'metricsAdmin' ? 'sidebar_active' : 'sidebar_nonactive'"
			@click.native="activeTab = 'metricsAdmin'"
			:onclick="topFunction()">
			<font-awesome-icon class="icon" icon="tachometer-alt" />
			<span style="margin-left: 15px; font-size: 1.3em">Metrics</span>
		</router-link>

        <router-link 
			:to="{ name: 'settingsAdmin' }"
			:class="activeTab === 'settingsAdmin' ? 'sidebar_active' : 'sidebar_nonactive'"
			@click.native="activeTab = 'settingsAdmin'"
			:onclick="topFunction()">
			<font-awesome-icon class="icon" icon="cogs" />
			<span style="margin-left: 15px; font-size: 1.3em">Settings</span>
		</router-link>
		
      </div>
      <!--sidebar end-->
      <div class="content">
        <div class="card">
          <slot/>
        </div>
      </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  data() {
    return {
      isActive: false,
	  activeTab: 'adminPanel',
        }
    },
    computed: mapState(['client']),
    methods: {
		logout() {
		this.$store.dispatch('logout')
		},
		topFunction() {
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
		},
  	},
	  async mounted() {
		const location = window.location.href
		const activePage = location.split('/')
		this.activeTab = activePage[activePage.length - 2]
	  }
    }
</script>

<style lang="css" scoped>

body{
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
}

header{
  z-index: 1;
  position: fixed;
  background: var(--bg);
  padding: 20px;
  width: calc(100% - 0%);
  top: 0;
  height: 70px;
}

.left_area h3{
  color:var(--white);
  margin: -10px;
  text-transform: uppercase;
  font-size: 22px;
  font-weight: 900;
}

.left_area span{
  color: var(--white);
}

.sidebar_active {
  background: var(--bg-superLight);
  color: var(--primaryDark) !important;
}

.sidebar_nonactive {
  background: var(--bg-bg-light);
  color: var(--bg-superLight);
}

.logout_btn{
  padding: 5px;
  width: 100px;
  background: var(--bg-light);
  text-decoration: none;
  float: right;
  font-size: 15px;
  font-weight: 100;
  color: var(--white);
  transition: 0.5s;
  transition-property: background;
}

.logout_btn:hover{
  background: #49535e;
}

.sidebar{
  z-index: 1;
  top: 0;
  background: var(--bg-light);;
  margin-top: 70px;
  padding-top: 30px;
  position: fixed;
  left: 0;
  width: 250px;
  height: calc(100% - 9%);
  transition: 0.5s;
  transition-property: left;
  overflow-y: auto;
}

.profile_info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sidebar .profile_info .profile_image{
  width: 100px;
  height: 100px;
  border-radius: 100px;
  margin-bottom: 10px;
}

.sidebar .profile_info h4{
  color: var(--white);
  margin-top: 0;
  margin-bottom: 50px;
  font-size: 1.2rem;
}

.sidebar a{
  color: var(--white);
  text-align: left;
  display: block;
  width: 100%;
  line-height: 55px;
  text-decoration: none;
  padding-left: 40px;
  box-sizing: border-box;
  transition: 0.5s;
  transition-property: background;
}

.sidebar a:hover{
  background:var(--bg);
}

.sidebar .no-hover:hover{
  background:var(--bg-light);
}

.sidebar .icon{
  /* padding-right: 10px; */
  font-size: 2em;
}

label #sidebar_btn{
  z-index: 1;
  color: var(--white);
  position: fixed;
  cursor: pointer;
  left: 20px;
  font-size: 30px;
  margin: 5px 0;
  transition: 0.5s;
  transition-property: color;
}

label #sidebar_btn:hover{
  background:var(--bg);
}

#check:checked ~ .sidebar{
  left: -185px;
}

#check:checked ~ .sidebar a span{
  display: none;
}

#check:checked ~ .sidebar a{
  font-size: 10px;
  margin-left: 165px;
  width: 100%;
}

.content{
  width: (100% - 250px);
  margin-top: 60px;
  padding: 20px;
  margin-left: 250px;
  background: url('../assets/static/images/bg.jpg');
  background-repeat: repeat-y;
  background-position: center;
  background-size: cover;
  height: 100vh;
  transition: 0.5s;
  z-index: -1;
}

#check:checked ~ .content{
  margin-left: 60px;
}

#check:checked ~ .sidebar .profile_info{
  display: none;
}

#check{
  display: none;
}

.mobile_nav{
  display: none;
}

.left_area h3 {
    font-weight: 600;
    color: var(--white);
}
.left_area span {
    font-weight: 100;
    color: var(--primary);
}

/* Responsive CSS */

@media screen and (min-width: 1000px){
  .logout_btn {
	  margin-top: -30px;
	  
  }
}

@media screen and (max-width: 500px){
  .logout_btn {
      margin-right: 0px;
	  margin-top: 15px;
	  
  }
}

@media screen and (max-width: 780px){
  .sidebar{
    display: none;
  }

  #sidebar_btn{
    display: none;
  }

  .content{
    margin-left: 0;
    margin-top: 0;
    padding: 10px 20px;
    transition: 0s;
    background-repeat: repeat-y !important;

  }

  #check:checked ~ .content{
    margin-left: 0;
  }

  .mobile_nav{
    display: block;
    width: calc(100% - 0%);
  }

  .nav_bar{
    background: var(--bg);
    width: (100% - 0px);
    margin-top: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
  }

  .nav_bar .mobile_profile_image{
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  .nav_bar .nav_btn{
    color: var(--white);
    font-size: 22px;
    cursor: pointer;
    transition: 0.5s;
    transition-property: color;
  }

  .nav_bar .nav_btn:hover{
  background:var(--bg);
  }

  .mobile_nav_items{
    background: var(--bg-light) !important;
    display: none;
  }

  .mobile_nav_items a{
    color: var(--white);
    display: block;
    text-align: center;
    letter-spacing: 1px;
    line-height: 60px;
    text-decoration: none;
    box-sizing: border-box;
    transition: 0.5s;
    transition-property: background;
  }
  .mobile_nav_items a:hover{
  background: var(--bg);
  }
  .mobile_nav_items .icon{
    padding-right: 10px;
    font-size: 1.4em;
  }
  .mobile_nav_items span{
    padding-left: 10px;
    font-size: 1.4em;
  }
  .active{
    display: block;
  }
}
</style>